const url = {
  baseUrl: process.env.REACT_APP_BE_URL,
};

export default url;
